import { BaseObject } from "@adgate/common/types/base-object.type";

export class ProductionRequestFilter
{
    client!: string;
    name!: string;
    requestId!: string;
    masterRefCode!: string;
    txid!: string
    creatorName!: string;
    createdFrom!: number | null;
    createdTo!: number | null;
    txId!: string;
    status!: BaseObject[];
    limit: number = 200;

    constructor()
    {

    }    
}